var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.type === 'error' ? 'error-msg-con' : 'success-msg-con'},[(_vm.type === 'error')?_c('svg',{staticClass:"t-icon info-outline",attrs:{"height":"18","width":"18"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }